import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pop-up-confirmation',
  templateUrl: './pop-up-confirmation.component.html',
  styleUrls: ['./pop-up-confirmation.component.css']
})
export class PopUpConfirmationComponent implements OnInit {

  @Input() monthlyConfirmAssets;
  constructor() { }

  ngOnInit(): void {
    console.log('monthly confirmation assets details', this.monthlyConfirmAssets);
  }
  closeModal() { }

}
